import { createSlice } from '@reduxjs/toolkit';
import { GetConsumeFleet, GetConsumeFleetGroup, GetConsumeGroup, getConsumable } from './consumeThunk';

const initialState = {
    currentPage: 1,
    pageSize: 100,    
    totalRecords: 0,
    selectedFleet: [],
    selectedGroup: [],
    filteredGroup: [],        
    searchText: '',
    fleets: [],
    groups: [],
    consumable: [],
    loadingFleet: true,
    loadingGroup: true
}

const consumeSlice = createSlice({
    name: 'consumeSlice',
    initialState,
    reducers: {
        setConsumable(state, action) {            
            state.consumable = action.payload;            
        },
        setCurrentPage(state, action){
            state.currentPage = action.payload;
        },
        setPageSize(state, action){
            state.pageSize = action.payload;
        },
        setTotalRecords(state, action) {
            state.totalRecords = action.payload;
        },
        setSelectedFleet(state, action) {
            state.selectedFleet = action.payload;
        },
        setSelectedGroup(state, action) {
            state.selectedGroup = action.payload;
        },
        setSearchText(state, action) {
            state.searchText = action.payload;
        },
        setFilteredGroup(state, action) {
            state.filteredGroup = action.payload;
        },
        setLoadingGroup(state, action) {
            state.loadingGroup = action.payload;
        },
        setLoadingFleet(state, action) {
            state.loadingFleet = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConsumable.fulfilled, (state, action) => {
                const response = action.payload.data;
                state.currentPage = response.CurrentPage;
                state.pageSize = response.PageSize;
                state.totalRecords = response.TotalRecords;
                state.consumable = response.Parts;
                state.groups = response.GroupTypes;
            })
            .addCase(getConsumable.rejected, (state, action) => {
                state.consumable = [];
            })
            .addCase(GetConsumeFleet.fulfilled, (state,action) =>{
                state.fleets = action.payload.data;
                state.loadingFleet = false;
            })
            .addCase(GetConsumeFleet.rejected, (state,action) => {
                state.fleets = [];
                state.loadingFleet = false;
            })
            .addCase(GetConsumeGroup.fulfilled, (state, action)=>{
                state.groups = action.payload.data;
            })
            .addCase(GetConsumeGroup.rejected, (state, action) => {
                state.groups = [];
            })
            .addCase(GetConsumeFleetGroup.fulfilled, (state,action) => {
                state.filteredGroup = action.payload.data.GroupTypes;
                state.loadingGroup = false;
            })
            .addCase(GetConsumeFleetGroup.rejected, (state, action) => {
                state.filteredGroup = [];
                state.loadingGroup = false;
            })
    }
});

export const { setConsumable, setCurrentPage, setTotalRecords, setSelectedFleet, setSelectedGroup, setSearchText, setFilteredGroup, setLoadingGroup, setLoadingFleet } = consumeSlice.actions;
export default consumeSlice.reducer;